exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carousel-carousel-4JtpuS65mwr{display:flex;flex-direction:row;flex-wrap:nowrap;overflow-x:auto;width:100%;height:100%;-webkit-overflow-scrolling:touch;-ms-overflow-style:none;-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory;-ms-scroll-snap-destination:0% 100%;scroll-snap-destination:0% 100%;-ms-scroll-snap-points-x:repeat(100%);scroll-snap-points-x:repeat(100%)}.carousel-carousel-4JtpuS65mwr::-webkit-scrollbar{background:transparent}.carousel-carousel-4JtpuS65mwr>*{width:inherit;height:inherit;flex:0 0 auto;box-sizing:border-box;padding:8px;scroll-snap-align:start}.carousel-indicator-dots-68Fj4jWQmwr{display:flex;flex-direction:row;justify-content:center}.carousel-indicator-dot-2MLlKpNvmwr{width:16px;height:16px}.carousel-indicator-dot-2MLlKpNvmwr:before{content:\"\";display:block;width:8px;height:8px;margin:4px;border-radius:50%;background:rgba(0,0,0,0.2)}.carousel-indicator-dot-2MLlKpNvmwr.carousel-selected-7jKwzuGUmwr:before{background:rgba(0,0,0,0.6)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"carousel": "carousel-carousel-4JtpuS65mwr",
	"indicator-dots": "carousel-indicator-dots-68Fj4jWQmwr",
	"indicatorDots": "carousel-indicator-dots-68Fj4jWQmwr",
	"indicator-dot": "carousel-indicator-dot-2MLlKpNvmwr",
	"indicatorDot": "carousel-indicator-dot-2MLlKpNvmwr",
	"selected": "carousel-selected-7jKwzuGUmwr"
};